export default __webpack_public_path__ + "5f36da3f50acb998da9e32125752f8d5.wav";